import { VFC } from 'react'
import { asModal } from 'src/components/hoc/asModal'
import { ModalArticle } from 'src/models/Article'
import {
  black,
  truewhite,
  _contributiontext,
  _menuicon,
  _profileoverlay,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { membersArticlePage } from 'src/utils/routes'
import styled, { css } from 'styled-components'
const ModalArticleDisplay: VFC<ModalArticle> = ({
  id,
  title,
  image,
  content,
  linkPath,
}) => (
  <Layout>
    <h2>ONLY STORYからのお知らせ</h2>
    <h1>{title}</h1>
    <div className="overflow-y-wrap">
      {image.url && <img src={`${image.url}`} alt="画像" />}
      <p className="link" dangerouslySetInnerHTML={{ __html: content }} />
    </div>
    {linkPath && (
      <PopUpButtonLink className="button" onClick={close} href={linkPath}>
        詳しく見る
      </PopUpButtonLink>
    )}
    {!linkPath && (
      <PopUpButtonLink
        className="button"
        onClick={close}
        href={membersArticlePage(id)}
      >
        詳しく見る
      </PopUpButtonLink>
    )}
  </Layout>
)

const modalOverlayStyle = css`
  backdrop-filter: blur(6px) brightness(0.5);
  background-color: ${_profileoverlay}80;
`

export const ModalArticleModal = asModal(ModalArticleDisplay, {
  overlayStyle: modalOverlayStyle,
  scrollable: true,
})

const Layout = styled.div`
  background-color: ${truewhite};
  border-radius: 16px;
  padding: 40px 0px 0px 0px;
  max-height: 690px;
  width: 730px;
  max-width: 85vw;

  h1 {
    font-weight: ${fontWeightBold};
    font-size: 24px;
    color: ${black};
    letter-spacing: 2px;
    line-height: 150%;
    margin: 0px 40px 24px 40px;
    overflow: hidden;
  }
  h2 {
    font-weight: ${fontWeightBold};
    font-size: 18px;
    color: ${_menuicon};
    letter-spacing: 2px;
    margin: 0px 40px 16px 40px;
  }
  img {
    width: 100%;
  }
  .overflow-y-wrap {
    max-height: 455px;
    overflow-y: scroll;
  }
  p {
    font-weight: ${fontWeightBold};
    font-size: 14px;
    color: ${black};
    letter-spacing: 1px;
    line-height: 150%;
    margin: 0px 40px 10px 40px;
  }
  img {
    margin: 0px 40px 24px 40px;
    width: calc(100% - 80px);
  }
  .link {
    a:hover {
      text-decoration: underline;
    }
  }
`
const PopUpButtonLink = styled.a`
  display: block;
  padding: 30px 40px;
  border-radius: 0px 0px 16px 16px;
  background-color: ${_contributiontext};
  color: ${truewhite};
  font-weight: ${fontWeightBold};
  margin: 24px 0px 0px 0px;
  text-align: center;
  height: 80px;
  width: 100%;
`
